'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const IdeaStateFactory = require('../factory/idea-state');
const IdeaAdminAPI = require('feedback/infra/api/admin/idea');

class IdeaStat extends Backbone.Model {
    getName() {
        return this.get('name');
    }

    getState() {
        return this.get('state');
    }

    getCount() {
        return this.get('count');
    }
}

class IdeaStatsCollection extends Backbone.Collection {
    comparator(model) {
        const name = model.getName();
        if(name == 'new') {
            return 0;
        }
        if(name == 'accepted') {
            return 1;
        }
        if(name == 'designing') {
            return 2;
        }
        if(name == 'working') {
            return 3;
        }
        if(name == 'releaseWaiting') {
            return 4;
        }
        if(name == 'released') {
            return 5;
        }
        return 6;
    }

    fetch() {
        return IdeaAdminAPI.getIdeaStats()
            .then(stats => {
                _.each(stats['statistics'], (count, name) => {
                    const stat = {
                        id: name,
                        name: name,
                        state: IdeaStateFactory.build(name),
                        count: count
                    };
                    this.add(new IdeaStat(stat), {merge: true});
                })
            });
    }

    fetchOnce() {
        if(!this._fetched) {
            this._fetched = this.fetch();
        }

        return this._fetched;
    }
}

module.exports = new IdeaStatsCollection();



// WEBPACK FOOTER //
// ./feedback/domain/collection/idea-stats.js